let r;!function(r){let o=function(r){return r.Info="Info",r.Error="Error",r}({});r.ToastType=o}(r||(r={}));export{r as ToastModel};
//# sourceMappingURL=ToastModel.js.map
